import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "infopopup-container p-inline-start-0" }
const _hoisted_2 = { class: "info-date" }
const _hoisted_3 = { class: "info-title" }
const _hoisted_4 = {
  key: 0,
  class: "info-desc"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getInfoPopups(), (infoPopup, index) => {
      return (_openBlock(), _createElementBlock("li", { key: index }, [
        _createElementVNode("div", {
          class: _normalizeClass(["infopopup info-general", _ctx.getClass(infoPopup)]),
          role: "alert"
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("small", null, _toDisplayString(_ctx.dateFormatted(infoPopup)), 1)
          ]),
          _createElementVNode("div", _hoisted_3, _toDisplayString(infoPopup.title), 1),
          (infoPopup.description)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(infoPopup.description), 1))
            : _createCommentVNode("", true)
        ], 2)
      ]))
    }), 128))
  ]))
}